import { CropSquare } from "@mui/icons-material";
import { Box, Button, Drawer, Stack, Typography } from "@mui/material";
import './termsConditionsBar.scss'
import { useState } from "react";
import { useNavigate } from "react-router";
import { PAGES_URL } from "../../../shared/constants/constants";

interface TnCBarInterface {
    messageType: string,
    open: boolean,
    setOpen: any,
    handleNext: any
    handleCancel: any
}

const TermsConditionsBar = ({messageType, open, setOpen, handleNext, handleCancel}:TnCBarInterface)=>{

    const navigate = useNavigate();

    const messages: any = {
        HSN_AI: ["The HSN code suggested by AI is generated based on available data and may not always be accurate. Please verify the recommended HSN code before proceeding and acknowledge that the final decision rests with you. The website's creators and operators are not responsible for any consequences resulting from the use of this content."]
    }

    const acceptMsg: any = {
        HSN_AI: "Acknowledge and Proceed"
    }

    return (
        <Drawer open={open} anchor="bottom" sx={{ 
            '& .MuiDrawer-paper': {
                backgroundColor: "#F0F9FF",
                px : 5
            } 
          }}>
            <Box py={2}>
                <Typography fontWeight={600} fontSize={24}>Terms and Conditions</Typography>
                <Typography fontWeight={500} fontSize={18} color={"#132F41"}>Accepting the terms</Typography>
                <ul className="listStyle">
                    {messages[messageType]?.map((message: string)=>{
                        return (
                            <li>
                                <Typography fontWeight={400} fontSize={17}>{message}</Typography>
                            </li>
                        )
                    })}
                </ul>
                <Stack spacing={2} direction={"row"} className="buttonBox"  display={"flex"} width={"100%"} justifyContent={"flex-end"} alignItems={"flex-end"}>
                    <Button className="cancelBtn" onClick={()=>{
                        setOpen(false)
                        handleCancel()
                    }} >
                        <Typography>Cancel</Typography>
                    </Button>
                    <Button className="ackBtn" onClick={()=>{
                        setOpen(false)
                        handleNext()
                    }} >
                        <Typography>{acceptMsg[messageType]??"Agree"}</Typography>
                    </Button>
                </Stack>
            </Box>
        </Drawer>
    )
}

export default  TermsConditionsBar;